export default __webpack_public_path__ + "static/media/doctor_man.545e990b.svg";